module.exports = __webpack_public_path__ + "img/xCode.d4c4cac4.jpeg";